// @flow

import type { HeaderMediaQueries } from 'web-ssr/app/common/components/ContentHeader/types';

// The mobile menu enables a very different DOM structure and a11y props. We
// have two media queries as a result of the content that displays when a user
// is logged in vs. logged out so this increased complexity slightly.
export const shouldEnableMobileMenu = ({
  isLoggedIn,
  mediaQueries,
}: {
  isLoggedIn: boolean,
  mediaQueries: HeaderMediaQueries,
}) =>
  (mediaQueries.mobileLoggedOutMediaQuery && !isLoggedIn) ||
  (mediaQueries.mobileLoggedInMediaQuery && isLoggedIn);
